import {
  ABTestingDarkUiTheme,
  ABTestingLightUiTheme,
  useABTesting,
} from "../ab-testing";
import {
  DarkModeUITheme,
  LightModeUITheme,
  PartialPreferences,
  ThemeMode,
} from "./preferences";

/**
 * The preferences an enrolled user starts on, sitting between the initial defaults
 * and whatever the user has persisted: an experiment replaces classic, and the
 * moment the user picks a theme themselves their choice wins.
 */
export function useABTestingPreferences(): PartialPreferences {
  const abTesting = useABTesting();

  return {
    theme: {
      [ThemeMode.Dark]: darkThemeByABTesting(abTesting.darkUiTheme),
      [ThemeMode.Light]: lightThemeByABTesting(abTesting.lightUiTheme),
    },
  };
}

function darkThemeByABTesting(
  darkUiTheme: ABTestingDarkUiTheme | undefined,
): DarkModeUITheme | undefined {
  if (darkUiTheme === undefined) return undefined;
  return darkModeUIThemes[darkUiTheme];
}

function lightThemeByABTesting(
  lightUiTheme: ABTestingLightUiTheme | undefined,
): LightModeUITheme | undefined {
  if (lightUiTheme === undefined) return undefined;
  return lightModeUIThemes[lightUiTheme];
}

const darkModeUIThemes: Record<ABTestingDarkUiTheme, DarkModeUITheme> = {
  [ABTestingDarkUiTheme.ClassicDark]: DarkModeUITheme.ClassicDark,
  [ABTestingDarkUiTheme.SportyDark]: DarkModeUITheme.SportyDark,
  [ABTestingDarkUiTheme.Stadium]: DarkModeUITheme.Stadium,
  [ABTestingDarkUiTheme.ChalkTalkDark]: DarkModeUITheme.ChalkTalkDark,
  [ABTestingDarkUiTheme.PlaybookPrintDark]: DarkModeUITheme.PlaybookPrintDark,
  [ABTestingDarkUiTheme.BroadcastDark]: DarkModeUITheme.BroadcastDark,
};

const lightModeUIThemes: Record<ABTestingLightUiTheme, LightModeUITheme> = {
  [ABTestingLightUiTheme.ClassicLight]: LightModeUITheme.ClassicLight,
  [ABTestingLightUiTheme.Turf]: LightModeUITheme.Turf,
  [ABTestingLightUiTheme.Whiteboard]: LightModeUITheme.Whiteboard,
  [ABTestingLightUiTheme.Notebook]: LightModeUITheme.Notebook,
  [ABTestingLightUiTheme.ChalkTalkLight]: LightModeUITheme.ChalkTalkLight,
  [ABTestingLightUiTheme.PlaybookPrintLight]:
    LightModeUITheme.PlaybookPrintLight,
  [ABTestingLightUiTheme.BroadcastLight]: LightModeUITheme.BroadcastLight,
};
